'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.analytics = undefined;

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _analytics;

exports.default = reducer;
exports.clear = clear;
exports.submitForm = submitForm;
exports.openModal = openModal;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CLEAR = 'redux-frontend/buffet/CLEAR';
var OPEN_MODAL = 'redux-frontend/buffet/OPEN_MODAL';

var SUBMIT_FORM = 'redux-frontend/buffet/SUBMIT_FORM';
var SUBMIT_FORM_SUCCESS = 'redux-frontend/buffet/SUBMIT_FORM_SUCCESS';
var SUBMIT_FORM_FAIL = 'redux-frontend/buffet/SUBMIT_FORM_FAIL';

var initialState = {
  openModal: false
};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case CLEAR:
      return initialState;
    case OPEN_MODAL:
      return (0, _extends3.default)({}, state, {
        openModal: action.open
      });
    default:
      return state;
  }
}

var analytics = exports.analytics = (_analytics = {}, (0, _defineProperty3.default)(_analytics, SUBMIT_FORM_SUCCESS, function (action) {
  return { name: 'Submit Form', category: 'Buffet', travelerName: action.data.name, travelerEmail: action.data.email, package: action.data.dayPackage, mobile: action.data.mobile, country: action.data.country, quantity: action.data.quantity, date: action.data.date };
}), (0, _defineProperty3.default)(_analytics, OPEN_MODAL, function (action) {
  return action.open ? { name: 'Open Modal', category: 'Buffet' } : { name: 'Close Modal', category: 'Buffet' };
}), _analytics);

function clear() {
  return { type: CLEAR };
}
function submitForm(data) {
  return {
    types: [SUBMIT_FORM, SUBMIT_FORM_SUCCESS, SUBMIT_FORM_FAIL],
    promise: function promise(client) {
      return client.post('/slack/buffet', { data: data });
    },
    data: data
  };
}
function openModal() {
  var open = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

  return {
    type: OPEN_MODAL,
    open: open
  };
}


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/buffet.js
// module id = 479
// module chunks = 47